export default "__VITE_ASSET__Dzvjd7y0__"